var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-radius":"4px","border":"1px solid #D9E4F8","padding":"24px","display":"flex","align-items":"center"}},[_c('div',{staticStyle:{"flex":"1","font-size":"12px","color":"#0E193B"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"font-size":"16px","font-weight":"bold","color":"#0E193B"}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }